export default __webpack_public_path__ + "static/media/flash_muted_poster.84622070.png";